<template>
  <div class="product-item-panel">
    <div :style="'background-image:url(' + itemData.bgUrl + ')'" class="product-item-img"></div>
    <div class="product-item-title">{{itemData.title}}</div>
    <div class="product-item-content">{{itemData.content}}</div>
    <div class="product-item-link">查看详情</div>
  </div>
</template>

<script>
  export default {
    name: 'ProductItem',

    props: {
      itemData: Object
    }
  }
</script>

<style scoped>
  .product-item-panel {
    display: inline-block;
    text-align: center;
    margin-right: 1.354vw;
  }

  .product-item-img {
    background-size: cover;
    background-position: center;
    height: 26.5625vw;
    width: 24.479vw;
    background-repeat: no-repeat;
    transition: all 0.3s;
  }

  .product-item-img:hover {
    opacity: 0.6;
  }

  .product-item-title {
    font-family: PingFangSC-Semibold;
    font-size: 1.875vw;
    color: #333333;
    text-align: center;
    margin-top: 1.41vw;
    transition: all 0.3s
  }

  .product-item-title:hover {
    color: #1158E8;
  }

  .product-item-content {
    font-family: PingFangSC-Regular;
    font-size: 1.042vw;
    color: #999999;
    text-align: center;
    line-height: 1.5625vw;
    width: 19.53vw;
    height: 3.125vw;
    margin: 0.521vw auto 0;
  }

  .product-item-link {
    width: 8.542vw;
    margin:1.875vw auto 5.156vw;
    background: #1158E8;
    font-family: PingFangSC-Medium;
    font-size: 1.146vw;
    color: #FFFFFF;
    letter-spacing: 0.095vw;
    text-align: center;
    line-height: 2.8125vw;
    box-shadow: 0px 0px 10px #1158E8;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductItem.vue